module.exports = __webpack_public_path__ + "static/img/Frame1171277103Mobile.6a662191.png";